import axiosInstance from "../lib/axiosInstance";

class settingsModel {

    constructor() {
        this.base_url = "/settings"
    }
    async list(query = []) {
       
        return (await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)).data;
    }
    
    async create(data = []) {
        return await axiosInstance.post(`${this.base_url}`, data);
    }

}

export default new settingsModel();